import { useCallback } from 'react';
import SpringConfigs from 'utils/constants/swarm/spring-configs';
import { isMobile } from 'utils/is-mobile';
import { CASINO_GAMES_SLIDER_LIMIT_MULTIPLIER } from '../constants/generic';
import { useCasinoGamesConditionalsValues } from '../providers/CasinoGamesConditionalsProvider';
import {
  CasinoGamesLoadMoreBtnType,
  useCasinoGamesConfigsValues
} from '../providers/CasinoGamesConfigsContext';
import { useCasinoGamesFetchParamsValues } from '../providers/CasinoGamesFetchParamsContext';
import { CasinoGamesFetchingParamsActionType } from '../state/reducer';
import { CasinoGamesDefaultConstants } from '../utils/default-constants';

export const useGamesLoadMore = () => {
  const { dispatchFetchParams, fetchParams } =
    useCasinoGamesFetchParamsValues();

  const { computedConfigs, configs } = useCasinoGamesConfigsValues();

  const { conditionals } = useCasinoGamesConditionalsValues();

  const handleLoadMore = useCallback(() => {
    if (fetchParams.offset === undefined || fetchParams.limit === undefined) {
      return;
    }

    if (conditionals.queryLoading) {
      return;
    }

    let gamesLimit = computedConfigs.gamesLimit;

    // In case of slider type, we need to change the limit and offset based on gamesRows and gamesPerRow
    if (
      computedConfigs.loadMoreButtonType === CasinoGamesLoadMoreBtnType.SLIDER
    ) {
      if (isMobile()) {
        gamesLimit = configs.mobileCustomSettings
          ? (configs.mobileCasinoGamesLimit as number)
          : (configs.casinoGamesLimit as number);
      } else {
        gamesLimit =
          (computedConfigs.gamesRows ||
            CasinoGamesDefaultConstants.GAMES_ROWS) *
          (computedConfigs.gamesPerRow ||
            CasinoGamesDefaultConstants.GAMES_PER_ROW) *
          CASINO_GAMES_SLIDER_LIMIT_MULTIPLIER;
      }
    }

    dispatchFetchParams({
      type: CasinoGamesFetchingParamsActionType.SET,
      payload: {
        offset: fetchParams.limit,
        limit:
          fetchParams.limit +
          Math.min(gamesLimit, SpringConfigs.CASINO_GAMES_FETCH_MAX_COUNT)
      }
    });
  }, [
    fetchParams.offset,
    fetchParams.limit,
    computedConfigs.gamesLimit,
    computedConfigs.loadMoreButtonType,
    computedConfigs.gamesRows,
    computedConfigs.gamesPerRow,
    conditionals.queryLoading,
    configs.mobileCustomSettings,
    configs.mobileCasinoGamesLimit,
    configs.casinoGamesLimit
  ]);

  return { handleLoadMore };
};
